import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

import IconSvg from 'components/Core/IconSvg';

import { PaginationWrapper } from './Pagination.styles';

const PaginationComponent = ({ onPageClick, initialPage, totalPages }) => {
  return (
    <PaginationWrapper>
      <ReactPaginate
        previousLabel={
          <span className="flex flex-row justify-center items-center pr-4">
            <IconSvg icon="arrow-left" className="text-primary lg:hidden" size={12} />
            <IconSvg icon="arrow-left" className="text-primary hidden lg:block" size={16} />
            <span className="pl-4 hidden md:inline">Prev</span>
          </span>
        }
        nextLabel={
          <span className="flex flex-row justify-center items-center pl-4">
            <span className="pr-4 hidden md:inline">Next</span>
            <IconSvg icon="arrow-right" className="text-primary lg:hidden" size={12} />
            <IconSvg icon="arrow-right" className="text-primary hidden lg:block" size={16} />
          </span>
        }
        breakLabel="..."
        breakClassName="break-me"
        pageCount={totalPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        initialPage={initialPage}
        onPageChange={onPageClick}
        containerClassName="pagination"
        subContainerClassName="pages pagination"
        activeClassName="active"
        disableInitialCallback
      />
    </PaginationWrapper>
  );
};

PaginationComponent.propTypes = {
  onPageClick: PropTypes.func.isRequired,
  initialPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
};
export default PaginationComponent;
